import type { ButtonHTMLAttributes } from 'react';
import styles from './GoldButton.module.css';

export function GoldButton({
  className,
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type={type} className={[styles.btn, className].filter(Boolean).join(' ')} {...props} />
  );
}
